import tonStyles from './../ton.json'

export default {
  default: {
    backgroundColor: tonStyles.colors.PrimaryBlack,
    border: `1px solid ${tonStyles.colors.PrimaryBlack}`,
    color: tonStyles.colors.PrimaryWhite
  },
  inverse: {
    backgroundColor: tonStyles.colors.PrimaryWhite,
    border: `1px solid ${tonStyles.colors.PrimaryBlack}`,
    color: tonStyles.colors.PrimaryBlack
  },
  disabled: {
    color: tonStyles.colors.SecondaryLightGrey,
    backgroundColor: tonStyles.colors.PrimaryWhite,
    border: `1px solid ${tonStyles.colors.LightGrey}`
  },
  hover: {
    color: tonStyles.colors.PrimaryBlack,
    backgroundColor: tonStyles.colors.SecondaryMidGrey,
    border: `1px solid ${tonStyles.colors.SecondaryMidGrey}`
  },
  hoverInverse: {
    backgroundColor: tonStyles.colors.PrimaryBlack,
    border: `1px solid ${tonStyles.colors.PrimaryBlack}`,
    color: tonStyles.colors.PrimaryWhite
  }
}
